<template>
  <div class="container-fluid pt-5">
    <div class="d-flex justify-content-center mt-5">
      <currencies-form class="col-lg-12"></currencies-form>
    </div>

    <b-modal
      v-model="showModal"
      title="Successful submit"
      header-bg-variant="success"
      header-text-variant="light">
      <div slot="modal-header-close"></div>
      <p>The transactions were submitted successfully.</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="redirect">OK</b-btn>
      </div>
    </b-modal>
  </div>
</template>


<script>
  import PricesForm from '../components/forms/PricesForm'

  export default {
    components: {
      currenciesForm: PricesForm,
    },
    data() {
      return {
        showModal: false,
      }
    },
    methods: {
      redirect() {
        this.showModal = false
        this.$router.push('/')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/PricesPage.vue